import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { RadioGroup, RadioGroupItem } from '@epoch-ui/components/RadioGroup/RadioGroup';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage
} from '@epoch-ui/components/Form/form';

export interface RadioFieldProps {
  name: string;
  label?: string | React.ReactNode;
  description?: string | React.ReactNode;
  className?: string;
  disabled?: boolean;
  onValueChange?: (value: string) => void;
  children: React.ReactNode;
}

export const RadioField = React.forwardRef<HTMLDivElement, RadioFieldProps>(
  ({ name, label, description, className, disabled, onValueChange, children }, ref) => {
    const formCtx = useFormContext();

    return (
      <FormField
        control={formCtx.control}
        name={name}
        render={({ field }) => (
          <FormItem ref={ref}>
            {label && (
              <FormLabel className={cn('tw-mb-0', disabled && 'tw-opacity-40')}>{label}</FormLabel>
            )}
            {description && (
              <FormDescription className={cn('tw-m-0', disabled && 'tw-opacity-40')}>
                {description}
              </FormDescription>
            )}
            <FormControl>
              <RadioGroup
                ref={field.ref}
                name={field.name}
                value={field.value}
                onValueChange={(value) => {
                  field.onChange(value);
                  onValueChange?.(value);
                }}
                className={cn('tw-mt-2', className)}
                disabled={disabled}
              >
                {children}
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    );
  }
);

RadioField.displayName = 'RadioField';

export { RadioGroupItem as RadioFieldItem };
